import { useRef, useEffect } from 'react'

// straight from the Hooks FAQ https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
export default function usePrevious (currentValue, defaultValue = {}) {
    const ref = useRef(defaultValue)

    useEffect(() => {
        ref.current = currentValue
    })

    return ref.current
}
